import { Component } from "vue-property-decorator"

import FIconBase from "./fIcon.client.base"

@Component
export default class FIconWeb extends FIconBase {}
